"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageBodyComponent = exports.handleAdd = exports.removeToastOnAnyAction = void 0;
/**
 * @module Manage generic component
 *
 * This is the component used accross phone, email, address flows
 * classes, plus any modifier classes and text/text-filled elements if there are any any.
 *
 * NOTE: text will not be positioned in any way by default. Supply a modifier class to position it, if needed.
 *
 * Sample Usage
 * <ManageBodyComponent object='{value}' etc />
 */
var React = require("react");
var constants_1 = require("../constants");
var pp_react_1 = require("@paypalcorp/pp-react");
var addressDisplay_1 = require("../containers/account/address/addressDisplay");
var badges_component_1 = require("../components/badges.component");
var add_new_component_1 = require("../components/add-new.component");
var commonUtils_1 = require("../common/utils/commonUtils");
var ajax_util_1 = require("../utils/ajax/ajax.util");
var phone_1 = require("../utils/container/phone");
var utils_1 = require("../common/utils/phones/utils");
var commonUtils_2 = require("../common/utils/commonUtils");
var page = require("page");
/*
 * This is the fix for toast is not closed when the user performs any operations on the manage page,
 * fix will be removed after the support from pp-react
 */
function removeToastOnAnyAction(props, obj) {
    if (props.typeOfAction) {
        props.performedAction(null);
        if (props.typeOfAction !== "remove") {
            commonUtils_1.modifyObjectWithFactor(obj, props.typeOfAction, true, false);
        }
    }
}
exports.removeToastOnAnyAction = removeToastOnAnyAction;
function handleSetPrimary(type, props, objTobeRendered, event) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].MAKE_PRIMARY;
    url = url.replace(":id", event.target.value);
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleEdit(type, props, objTobeRendered, event) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].EDIT;
    url = url.replace(":id", event.target.value);
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleRemove(type, props, objTobeRendered, event) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].REMOVE;
    url = url.replace(":id", event.target.value);
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleOverFlowMenuClick(url, props, objTobeRendered, e) {
    e.preventDefault();
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleChangePrimary(props, phoneType, objTobeRendered, event) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.CHANGE_PRIMARY;
    url = url.replace(":id", event.target.value);
    props.changePrimaryType(phoneType);
    page(url);
    removeToastOnAnyAction(props, objTobeRendered);
}
function handleAdd(type, props, objTobeRendered, event) {
    event.preventDefault();
    page(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].ADD);
    removeToastOnAnyAction(props, objTobeRendered);
}
exports.handleAdd = handleAdd;
function handleResendConfirmation(ref, props, objTobeRendered, event, setSpinner) {
    event.preventDefault();
    var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.VALIDATE_CONFIRMATION, phoneToBeConfirmed = commonUtils_2.findObjectInListById(objTobeRendered, event.target.value);
    url = url.replace(":id", event.target.value);
    var formData = {};
    formData["id"] = event.target.value;
    formData["isTcpaEnabled"] = phone_1.isTcpaEnabled(phoneToBeConfirmed, props);
    formData["isSCAEnabled"] = utils_1.isSCAEnabled(props.features);
    setSpinner(true);
    ajax_util_1.default.post$(props.dispatch, props._csrf, "" + constants_1.default.ROUTES.API.PHONES.CONFIRM, formData, { component: { name: constants_1.default.VIEWS.PHONES.MANAGE } })
        .then(function (phoneInfo) {
        page(url);
    })
        .catch(function (error) {
        page(url);
    });
    removeToastOnAnyAction(props, objTobeRendered);
}
function ItemsList(_a) {
    var _b = _a.type, type = _b === void 0 ? "" : _b, obj = _a.obj, content = _a.content, commonContent = _a.commonContent;
    switch (type) {
        case "ADDRESSES":
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "manageComponent-info alignLeft" },
                    React.createElement(addressDisplay_1.default, { layout: obj.displayMetadata.layout })),
                obj && obj.cardList && obj.cardList.length > 0 && (React.createElement("div", { className: "toolTipComponent toolTipComponent_space", role: "toolbar" },
                    React.createElement(pp_react_1.Icon, { className: "cardInfo cardInfo-icon cardInfo_background cardInfo_secondary cardsIcon_secondary", name: "card", size: "xs" }),
                    React.createElement(pp_react_1.Text, { size: "sm", className: "cardInfo cardInfo-icon cardInfo_background cardsIcon_secondary" }, obj.cardList.length === 1 && content.cards.one
                        ? content.cards.one.replace("{numberOfCards}", obj.cardList.length)
                        : content.cards.info.replace("{numberOfCards}", obj.cardList.length)),
                    React.createElement(pp_react_1.Tooltip, { className: "cardInfo tooltip-description", name: "cardsDetailsToolTip", description: obj.cardList.map(function (card) {
                            var cardName = card.name.toLowerCase();
                            return (React.createElement("div", null,
                                React.createElement("img", { className: "cardsComponent cardsComponent_secondary", src: card.cardArt }),
                                React.createElement(pp_react_1.Text, { className: "cardsComponent" },
                                    card.name
                                        .toLowerCase()
                                        .charAt(0)
                                        .toUpperCase() +
                                        cardName.slice(1),
                                    " ",
                                    " ••••" + card.lastFour)));
                        }) })))));
        case "PHONES":
            return (React.createElement(React.Fragment, null,
                obj &&
                    obj.type === "MOBILE" &&
                    !obj.confirmed &&
                    phone_1.phoneHasConfirmationFeature(obj.type, obj.isMobileCowConfirmable) && (React.createElement(pp_react_1.Badge, { className: "badgeComponent", type: "critical" }, commonContent.unconfirmed)),
                obj && (React.createElement(pp_react_1.Text, { size: "md", className: "manageComponent-info alignLeft" }, obj.maskedSubscriberNumber))));
    }
}
function ButtonsList(_a) {
    var ref = _a.ref, _b = _a.type, type = _b === void 0 ? "" : _b, valueTobeRendered = _a.valueTobeRendered, objTobeRendered = _a.objTobeRendered, content = _a.content, props = _a.props, commonContent = _a.commonContent, fpti = _a.fpti, setSpinner = _a.setSpinner;
    switch (type) {
        case "ADDRESSES":
            return (React.createElement(React.Fragment, null,
                valueTobeRendered && valueTobeRendered.primary && (React.createElement("div", { className: "manageButtons manageButtons_secondary" },
                    React.createElement(pp_react_1.Button, { name: fpti.edit, size: "sm", secondary: true, className: "manageButtons_space manageButtonsBlock_primary", id: "edit-primary", value: valueTobeRendered.id, onClick: function (e) {
                            return handleEdit(type, props, objTobeRendered, e);
                        } }, commonContent.edit),
                    objTobeRendered.length > 1 && (React.createElement(pp_react_1.Button, { name: fpti.remove, size: "sm", secondary: true, className: "manageButtons_space manageButtonsBlock_primary", id: "remove", value: valueTobeRendered.id, onClick: function (e) {
                            return handleRemove(type, props, objTobeRendered, e);
                        } }, commonContent.remove)))),
                valueTobeRendered && !valueTobeRendered.primary && (React.createElement("div", null,
                    React.createElement("div", { className: "editRemoveBlock" },
                        React.createElement("div", { className: "manageButtons manageButtons_secondary" },
                            React.createElement(pp_react_1.Button, { name: fpti.setAsPrimary, size: "sm", className: "manageButtons_space", id: "set-primary", value: valueTobeRendered.id, secondary: true, onClick: function (e) {
                                    return handleSetPrimary(type, props, objTobeRendered, e);
                                } }, content.managePrimary.button),
                            React.createElement(pp_react_1.Button, { name: fpti.edit, className: "manageButtons_space", size: "sm", id: "edit-non-primary", secondary: true, value: valueTobeRendered.id, onClick: function (e) {
                                    return handleEdit(type, props, objTobeRendered, e);
                                } }, commonContent.edit),
                            React.createElement(pp_react_1.Button, { name: fpti.remove, size: "sm", className: "manageButtons_space", secondary: true, id: "remove-non-primary", value: valueTobeRendered.id, onClick: function (e) {
                                    return handleRemove(type, props, objTobeRendered, e);
                                } }, commonContent.remove))),
                    React.createElement("div", { className: "overFlowBlock" },
                        React.createElement(pp_react_1.Button, { name: fpti.setAsPrimary, size: "sm", id: "set-primary", value: valueTobeRendered.id, secondary: true, onClick: function (e) {
                                return handleSetPrimary(type, props, objTobeRendered, e);
                            } }, content.managePrimary.button),
                        React.createElement("div", { className: "ppvx_overflow-menu" },
                            React.createElement("button", { className: "normalLineHeight ppvx_overflow-menu__btn overFlowMenu_second", "data-overflow-menu": "editRemoveMenu" +
                                    valueTobeRendered.id, tabIndex: 0, "aria-label": "Overflow", "aria-haspopup": "true", "aria-expanded": "false" }),
                            React.createElement("ul", { className: "ppvx_overflow-menu__list", tabIndex: -1, role: "menu", "aria-label": "Overflow", id: "editRemoveMenu" +
                                    valueTobeRendered.id },
                                React.createElement("li", { role: "presentation" },
                                    React.createElement("a", { onClick: function (e) {
                                            return handleOverFlowMenuClick((constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].EDIT).replace(":id", valueTobeRendered.id), props, objTobeRendered, e);
                                        }, className: "ppvx_overflow-menu__list-item", role: "menuitem", tabIndex: -1 },
                                        React.createElement("span", { className: "ppvx_icon ppvx_icon--size_sm ppvx_icon-edit overflow-menu_icon" }),
                                        React.createElement("span", { className: "overflow-menu_item ppvx_text--md" }, commonContent.edit))),
                                React.createElement("li", { role: "presentation" },
                                    React.createElement("a", { onClick: function (e) {
                                            return handleOverFlowMenuClick((constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES[type].REMOVE).replace(":id", valueTobeRendered.id), props, objTobeRendered, e);
                                        }, className: "ppvx_overflow-menu__list-item", role: "menuitem", tabIndex: -1 },
                                        React.createElement("span", { className: "ppvx_icon ppvx_icon--size_sm ppvx_icon-trash overflow-menu_icon" }),
                                        React.createElement("span", { className: "overflow-menu_item ppvx_text--md" }, commonContent.remove))))))))));
        case "PHONES":
            return (React.createElement(React.Fragment, null, valueTobeRendered && (React.createElement("div", { className: "manageButtons manageButtons_secondary" },
                !valueTobeRendered.primary &&
                    phone_1.canBeSetAsPrimary(valueTobeRendered) && (React.createElement(pp_react_1.Button, { size: "sm", className: "manageButtons_space", id: "test_manage_makePrimaryButton", value: valueTobeRendered.id, secondary: true, name: fpti.makePrimary, onClick: function (e) {
                        return handleSetPrimary(type, props, objTobeRendered, e);
                    } }, content.manageMakePrimary.link)),
                valueTobeRendered.type === "MOBILE" &&
                    !valueTobeRendered.confirmed &&
                    phone_1.phoneHasConfirmationFeature(valueTobeRendered.type, valueTobeRendered.isMobileCowConfirmable) && (React.createElement(pp_react_1.Button, { size: "sm", className: "manageButtons_space", value: valueTobeRendered.id, secondary: true, name: fpti.resendConfirmation, onClick: function (e) {
                        return handleResendConfirmation(ref, props, objTobeRendered, e, setSpinner);
                    } }, content.manageResendConfirmation.link)),
                !valueTobeRendered.primary && (React.createElement(pp_react_1.Button, { size: "sm", secondary: true, className: "manageButtons_space", id: "test_manage_editButton", value: valueTobeRendered.id, name: fpti.edit, onClick: function (e) {
                        return handleEdit(type, props, objTobeRendered, e);
                    } }, commonContent.edit)),
                valueTobeRendered.primary && (React.createElement(pp_react_1.Button, { size: "sm", secondary: true, className: "manageButtons_space", id: "test_manage_changePrimaryButton", value: valueTobeRendered.id, name: fpti.changePrimary, onClick: function (e) {
                        return handleChangePrimary(props, valueTobeRendered.type, objTobeRendered, e);
                    } }, commonContent.change)),
                !valueTobeRendered.primary && (React.createElement(pp_react_1.Button, { size: "sm", secondary: true, className: "manageButtons_space", id: "test_manage_removeButton", value: valueTobeRendered.id, name: fpti.remove, onClick: function (e) {
                        return handleRemove(type, props, objTobeRendered, e);
                    } }, commonContent.remove))))));
    }
}
function ManageBodyComponent(_a) {
    var ref = _a.ref, _b = _a.objTobeRendered, objTobeRendered = _b === void 0 ? [] : _b, _c = _a.type, type = _c === void 0 ? "" : _c, content = _a.content, commonContent = _a.commonContent, fpti = _a.fpti, props = _a.props, setSpinner = _a.setSpinner;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "manageComponent-header alignLeft" },
            React.createElement(pp_react_1.Text, { size: "xl3", className: "manageComponent-header_content" }, content.manage.header),
            React.createElement(pp_react_1.Text, { size: "sm", className: "manageComponent-info_secondary" }, content.manage.info),
            React.createElement(add_new_component_1.AddNewLinkComponent, { type: type, fpti: fpti, content: content, props: props, objTobeRendered: objTobeRendered })),
        React.createElement(pp_react_1.Divider, null),
        objTobeRendered.length > 0 &&
            objTobeRendered.map(function (valueTobeRendered) { return (React.createElement(React.Fragment, null,
                React.createElement(pp_react_1.Container, { fluid: true, className: "manageComponent-header_secondary alignLeft", id: valueTobeRendered && valueTobeRendered.id },
                    React.createElement(badges_component_1.BadgeByIntentComponent, { commonContent: commonContent, item: valueTobeRendered, type: type, content: content }),
                    React.createElement(ItemsList, { type: type, obj: valueTobeRendered, commonContent: commonContent, content: content }),
                    React.createElement(ButtonsList, { ref: ref, type: type, valueTobeRendered: valueTobeRendered, objTobeRendered: objTobeRendered, commonContent: commonContent, content: content, props: props, fpti: fpti, setSpinner: setSpinner })),
                React.createElement(pp_react_1.Divider, null))); })));
}
exports.ManageBodyComponent = ManageBodyComponent;
